<template>
  <div ref="editorDOM" class="examBook">
    <div class="windowInfoWrap m-main" ref="innerDOM">
      <div v-if="showTableDetail == true" class="tableDetailList">
        <div class="tableDetail">
          <div class="title1">{{ packageName }}</div>
          <div class="mobileTable" v-if="SCREEN.mobile">
            <div
              class="tableData"
              v-for="(item, index) in medicalExamDetailData"
              :key="index"
            >
              <div class="item">
                <div class="left">项目：</div>
                <div class="right">{{ item.itemName }}</div>
              </div>
              <div class="item">
                <div class="left">具体内容：</div>
                <div class="right">{{ item.itemContent }}</div>
              </div>
              <div class="item">
                <div class="left">临床意义：</div>
                <div class="right">{{ item.itemMean }}</div>
              </div>
            </div>
          </div>
          <div v-else class="tablebox">
            <a-table
              :columns="columns2"
              :data-source="medicalExamDetailData"
              :pagination="false"
            >
            </a-table>
          </div>
        </div>
        <div class="tip">
          <span class="s1">备注：</span>
          <div class="desc">
            1）套餐检项如若有变化，请以在官方商城实际购买的套餐检项为准<br />
            2）根据人社部、教育部、卫生部[2010]12号文件精神，提供入学、就业体检服务时，不得对受检者开展乙肝项目检测；<br />
            健康体检时，非因受检者本人要求，不得主动提供乙肝项目检测，受检者本人要求进行乙肝项目检测的，有关体检报告密封交受检者本人或其指定的人员。
          </div>
        </div>
        <div class="moreBtn">
          <a href="javascript:;" @click="showMask()">
            <i>预约套餐</i>
          </a>
        </div>
      </div>
      <div v-if="showTableDetail == false" class="bookSteps">
        <div class="title">体检预约</div>
        <div class="steps">
          <a-steps progress-dot :current="current" @change="stepChange">
            <a-step
              v-for="item in steps"
              :key="item.title"
              :title="item.title"
            />
          </a-steps>
        </div>
        <div class="box">
          <div class="steps-content1" v-if="current == 0">
            <a-form>
              <div class="tit1">选择预约日期</div>
              <a-form-item label="">
                <!-- <a-date-picker
                  style="width: 200px;margin-right:8px"
                  format="YYYY-MM-DD"
                  placeholder="请选择"
                  v-model="examBookForm.reserveDate"
                /> -->
                <a-select v-model="examBookForm.reserveDate" style="width: 200px;margin-right:8px">
                  <a-select-option 
                  v-model="item.date" 
                  v-for="(item, index) in dutyDateList" 
                  :key="index" 
                  :disabled="item.dateFlag == 1">
                    {{item.date}}
                  </a-select-option>
                </a-select>
              </a-form-item>
              <div class="tit1" style="margin-top:10px;">选择就诊人</div>
              <a-form-item label="">
                <a-select
                  style="width: 200px;margin-right:8px;"
                  v-model="examBookForm.hisPatientName"
                  :value="hisPatientId"
                  @change="handleSeletcPatientChange"
                >
                  <a-select-option
                    :value="items.hisId"
                    v-for="(items, index) in hisPatientNameList"
                    :key="index"
                  >
                    {{ items.name }}
                  </a-select-option>
                </a-select>
                <a
                id="tjjzr"
                href="javascript:void(0);"
                datanum="1"
                style="background: #0078d4;font-size: 16px;border-radius: 200px;text-align: center;display: inline-block;padding: 0 15px;height:32px;line-height:32px;margin-top:5px;color:white;"
                @click="addNewPatient()"
                >添加新的就诊人</a
              >
              </a-form-item>
              <!-- <AddPersonAgreement v-if="mic.showCurProtocol" v-model="agreeCheck" :michref="mic.curMic.micUrl" hospital="sz" /> -->
              <AddPersonAgreement v-model="agreeCheck" :michref="mic.latestMic.micUrl" hospital="sz" />

            </a-form>

            <div class="confirmBtn">
              <a href="javascript:;" id="tj_button" class="-dis" @click="handleSubmit">
                <i>确认预约</i>
              </a>
            </div>
            <div class="guahao3page1_alert" v-if="confirm">
              <a href="javascript:;" class="close" @click="closePop"></a>
              <div class="inner">
                <div class="tit2">添加新的就诊人</div>
                <a-form :label-col="{ span: 6 }" :wrapper-col="{ span: 13 }">
                  <a-form-item label="姓名：">
                    <a-input v-model="consultantForm.name"/>
                  </a-form-item>
                  <a-form-item label="证件类型：">
                    <a-select
                      @change="handleSelectChange"
                      v-model="consultantForm.idType"
                    >
                      <a-select-option
                        :value="item.id"
                        v-for="(item, index) in zjTypeList"
                        :key="index"
                      >
                        {{ item.name }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                  <a-form-item label="证件号码：">
                    <a-input @keyup="enterIdNo" v-model="consultantForm.idNo" :maxLength="30"/>
                  </a-form-item>
                  <a-form-item label="性别：">
                    <a-select v-model="consultantForm.gender">
                      <a-select-option
                        :value="item.id"
                        v-for="(item, index) in genderList"
                        :key="index"
                      >
                        {{ item.name }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                  <a-form-item label="出生日期：">
                    <a-date-picker
                      v-model="consultantForm.birthday"
                      valueFormat="YYYY-MM-DD"
                      :format="dateFormat"
                      placeholder="请选择"
                      :disabled-date="pickerOptions"
                      :disabled="consultantForm.idType == '01'"
                    />
                  </a-form-item>
                  <a-form-item label="手机号码：">
                    <a-input v-model="consultantForm.phone"/>
                  </a-form-item>
                  <!-- <a-form-item label="验证码：">
                    <a-input-search
                      v-model="consultantForm.verifyCode"
                      :enter-button="codeTimer?codeSecond+'s后获取':'获取验证码'"
                      @search="getVerifyCode"
                    />
                  </a-form-item> -->
                  <a-form-item label="与本人关系：">
                    <a-select v-model="consultantForm.relation">
                      <a-select-option
                        :value="item.id"
                        v-for="(item, index) in relationshipList"
                        :key="index"
                      >
                        {{ item.name }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-form>
                <br/>
                <AddPersonAgreement v-model="consultantForm.agreeCheck" :section="true" :sectiontips="true" :showpersonal="false" hospital="sz" />
                <AddPersonAgreement v-model="consultantForm.agree360Check" :showtips="false" :michref="mic.latestMic.micUrl" hospital="sz" />

                <div class="guahao3page1-button" html-type="submit">
                  <a
                    id="patientAdd"
                    href="javascript:void(0);"
                    @click="handleConsultantOk()"
                  >
                    <i>确认添加</i>
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div class="steps-content2" v-if="current == 1">
            <div v-if="ifSuccess == true" class="boxSuccess">
              <div class="statebox">
                <div class="tit">
                  预约成功
                </div>
                <div class="btnSearch">
                  <router-link
                    class="btn2_book"
                    to="/personalCenter/personalList/#5"
                  >
                    <span>
                      预约记录查询
                    </span></router-link
                  >
                  <a
                    class="btn2_pay"
                    @click="SCREEN.mobile?selectPaymentPhone():goExamPayment()"
                  >
                    <span>
                      去支付
                    </span></a
                  >
                </div>
              </div>
              <div class="box2box">
                <div class="boxitem">
                  <div class="tit1">个人基本信息</div>
                  <div class="textlist clear">
                    <div class="item1">
                      姓名：{{ examBookList.patientName }}
                    </div>
                    <div class="item1">证件号：{{ idNoHide }}</div>
                    <div class="item1">手机号码：{{ phone }}</div>
                  </div>
                </div>
                <div class="boxitem">
                  <div class="tit1">体检预约信息</div>
                  <div class="textlist clear">
                    <div class="item1">
                      套餐名称：{{ examBookList.packageName }}
                    </div>

                    <div class="item1">
                      预约时间：{{ examBookList.reserveDate }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="ifSuccess == false" class="boxFail">
              <div class="statebox statebox1" id="hbg">
                <div class="tit">预约套餐失败，请重试，或联系工作人员</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mask50" v-if="showMoreFlag"></div>
    <div class="contactfixed" ref="yyxzref" v-if="showMoreFlag">
      <div @click="closeRemindPop" class="close"></div>
      <div class="inner">
        <div class="scroll">
          <div class="mCustomScrollBox">
            <div class="mCSB_container">
              <div class="tit">预约须知</div>
              <div class="content">
                &nbsp;体检前注意事项：<br />
                1、为了保证体检质量，请您检前三天清单饮食，勿饮酒，体检前一晚十点钟之后禁食禁水，早些休息，体检当天空腹，带上身份证前来<br />
                2、体检当日穿宽松衣物，尽量不带首饰便于查体，女性避开月经期；<br />
                3、有高血压病史允许喝一口白水吃药，胰岛素及降糖药物当日晨起暂停；<br />
                4、半年内有备孕计划者，勿做DR等放射性检查项目；<br />
                5、老年特殊人群需家属陪伴。<br />
                <br />
                <br />
              </div>
            </div>
          </div>
        </div>
        <div class="operbox">
          <div class="got1">
            <a-checkbox @change="checkChange">
              我已知晓
            </a-checkbox>

            <!-- <input type="checkbox" name="ty" value="1" id="fxk" />
            <label for="fxk">我已知晓</label> -->
          </div>

          <div class="nextBtn" v-if="showNextBtn" @click="confirmAppointment()">
            <span class="operbtn1">下一步</span>
          </div>
        </div>
      </div>
    </div>

    <!-- 支付弹框 -->
    <div v-show="paymentVisible">
      <div class="wemsk"></div>
      <div class="pay-model-box">
        <div class="pay-main-box">
          <div class="title">
            <div class="top-title">预约成功<span class="close-span" @click="closePaymentModal">x</span></div>
            <div class="two-box">您预约的<span>{{examBookTime}}</span>{{examBooKMail}}预约成功</div>
            <div class="three-box">请于<span>30分钟</span>内完成支付，如在有效期内未完成支付，将自动为您取消预约</div>
          </div>
          <div class="pay-money">
            应付金额：<span>{{paymentFee}}</span>元
          </div>
          <div class="img-box">
            <div class="left-img-box">
              <div class="qrcode-out-box">
                <div id="qrcode" class="qrcode-box"></div>
              </div>
              <div class="bottom-remind-box">
                <img class="img" src="../images/sm.png" alt="">
                <div class="txt">
                  请使用微信、支付宝<br>扫码支付
                </div>
              </div>
            </div>
            <div class="right-img-box">
              <img src="../images/payBg.png" alt="">
            </div>
          </div>
          <div class="red-txt-box">
            <div class="content-red-box">
              <img src="../images/gth.png" alt="">
              距离二维码过期还剩<span>{{ num }}</span>秒，过期后请重新获取二维码
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 支付成功弹框 -->
    <div v-if="paySuccessVisible">
      <div class="wemsk"></div>
      <div class="pay-success-model-box">
        <div class="top-title">支付成功<span class="close-span" @click="closePaySuccessModal">x</span></div>
        <div class="middle-box">
          <img src="../images/success.png" alt="">
          您已成功付款<span>{{ paymentFee }}</span>元
        </div>
        <div class="bottom-box">
          <span>{{paySuccessNum}}</span>s后自动关闭
        </div>
      </div>
    </div>

    <!-- 手机支付选择弹框 -->
    <div v-if="selectPayPhoneVisible">
      <div class="wemsk"></div>
      <div class="pay-success-model-box">
        <div class="top-title">请选择支付方式</div>
        <div class="payRadioGroup">
          <a-radio-group v-model="paySelectValue" @change="onChangePayMethod">
            <!-- <a-radio class="payMethodRadio" style="display:block; width:100%; height:30px;" :value="1">
              <div style="display:flex">
                <img style="width:20px; margin-left:20px; margin-right:10px" src="../images/wxpay.png" alt="" />
                <span>微信支付</span>
              </div>
            </a-radio> -->
            <a-radio class="payMethodRadio"
              :value="2"
              style="margin-left:20px">
              <div class="payMethodRadio1">
                <img
                  src="../images/alipay.png"
                  alt=""
                  style="width:20px;height:20px;margin-left:15px"
                />
                <span style="margin-left:5px">支付宝支付</span>
              </div>
            </a-radio>
          </a-radio-group>
        </div>
        <div class="topaybtn">
          <a-button class="topaybtn1" type="default" @click="payMenthodCancel">取消</a-button>
          <a-button class="topaybtn1" type="primary" @click="payMenthodConfirm">确定</a-button>
        </div>
      </div>
    </div>

    <!-- 手机支付中弹框 -->
    <div v-if="payPhoneVisible">
      <div class="wemsk"></div>
      <div class="pay-success-model-box">
        <div class="top-title">支付中<span class="close-span" @click="closePayPhoneModal">x</span></div>
        <div class="middle-box">
          <!-- <img src="../images/success.png" alt=""> -->
         请于30分钟内完成支付，如在有效期内未完成支付，将自动为您取消预约
        </div>
        <div class="bottom-box">
          <span>{{num}}</span>s后自动关闭，请重新获取支付链接
        </div>
      </div>
    </div>

    <!-- 是否支付完成弹窗begin -->
    <div v-if="showHasPaySuccess">
      <div class="wemsk"></div>
      <div class="has-pay-success">
        <div class="gth-box">
          <div class="gth">
            !
          </div>
        </div>
        <div class="txt">请确认是否支付完成</div>
        <div class="btn-box">
          <p @click="refreshPay">重新支付</p>
          <p class="red-btn" @click="hasPaySuccess">已完成支付</p>
        </div>
      </div>
    </div>
    <!-- 是否支付完成弹窗end -->

  </div>
</template>

<script>
import { JSEncrypt } from "jsencrypt";
import { MIC_CONFIG } from "@/utils/constant";
import AddPersonAgreement from "@/components/hospitalPersonalList/addPersonAgreement"
import{ encryptByDES, checkIdNo, checkPhoneNo, checkIdTypes} from '@/utils/index';

export default {
  name: "hospital-physicalExaminationPackageDetail-001-sz",
  components: {
    AddPersonAgreement,
  },
  data() {
    return Object.assign(
      {
        columns2: [
          {
            title: "项目",
            dataIndex: "itemName",
            key: "itemName",
            width: 150
          },
          {
            title: "具体内容",
            dataIndex: "itemContent",
            key: "itemContent"
          },
          {
            title: "临床意义",
            dataIndex: "itemMean",
            key: "itemMean"
          },
        ],
        medicalExamDetailData: [
          // {
          //   itemName: "一般检查A",
          //   itemContent: "身高,体重,体重指数BMI,血压,脉搏，腰围臀围"
          // },
          // {
          //   itemName: "内科检查",
          //   itemContent: "心脏,胸廓,肺部,肝脏,脾脏,肾脏,下肢浮肿"
          // },
          // {
          //   itemName: "外科检查B",
          //   itemContent: "皮肤,浅表淋巴结,甲状腺,乳房,脊柱,四肢关节,肛门指诊"
          // },
          // {
          //   itemName: "眼科检查B",
          //   itemContent:
          //     "视力，辨色力，外眼（眼睑，结膜，巩膜，角膜，瞳孔，眼球）,眼底检查，裂隙灯检查"
          // },
          // {
          //   itemName: "耳鼻喉科检查",
          //   itemContent: "外耳道、鼓膜、鼻腔、鼻窦、咽喉"
          // },
          // {
          //   itemName: "碳14呼气试验",
          //   itemContent: "幽门螺旋杆菌"
          // },
          // {
          //   itemName: "肝功八项",
          //   itemContent:
          //     "丙氨酸氨基转移酶,天门冬氨酸氨基转移酶,总蛋白,γ-谷氨酰基转移酶,总胆红素,直接胆红素,碱性磷酸酶,白蛋白"
          // }
        ],
        publicKey: "",
        titleDetail: "体检名称",
        showNextBtn: false,
        showMoreFlag: false,
        packageCode: this.$route.query.packageCode || "",
        showTableDetail: true,
        hisPatientNameList: [], //就诊人列表
        current: 0,
        steps: [{ title: "选择时间" }, { title: "预约成功" }],
        confirm: false,        // 添加就诊人弹框
        // zjTypeList: [
        //   {
        //     id: "01",
        //     name: "居民身份证"
        //   },
        //   {
        //     id: "03",
        //     name: "护照"
        //   },
        //   {
        //     id: "06",
        //     name: "港澳居民来往内地通行证"
        //   },
        //   {
        //     id: "07",
        //     name: "台湾居民来往内地通行证"
        //   }
        // ],
        zjTypeList: [
        { id: '01', name: '居民身份证' },
        { id: '02', name: '户口簿' },
        { id: '03', name: '中国人民解放军军人保障卡' },
        { id: '04', name: '军官证' },
        { id: '05', name: '警官证' },
        { id: '06', name: '士兵证' },
        { id: '07', name: '护照' },
        { id: '08', name: '港澳居民来往内地通行证' },
        { id: '09', name: '中华人民共和国来往港澳通行证' },
        { id: '10', name: '台湾居民来往大陆通行证' },
        { id: '11', name: '大陆居民往来台湾通行证' },
        { id: '13', name: '外国人永久居留身份证' },
      ],
        genderList: [
          {
            name: "男",
            id: "1"
          },
          {
            name: "女",
            id: "2"
          }
        ],
        relationshipList: [
          {
            id: "0",
            name: "本人"
          },
          {
            id: "1",
            name: "子女"
          },
          {
            id: "2",
            name: "父母"
          },
          {
            id: "3",
            name: "夫妻"
          },
          {
            id: "4",
            name: "其它"
          }
        ],
        examBookForm: {
          hisPatientName: "",
          reserveDate: ""
        },
        dateFormat: 'YYYY-MM-DD',
        consultantForm: {
          sys: "ohealth",
          hospitalCode: "",
          name: "",
          phone: "",
          idType: "01",
          idNo: "",
          birthday: "",
          gender: "1",
          relation: "0",
          verifyCode: "",
          source: "web",
          agreeCheck: false, // 确认添加就诊人-勾选协议
          agree360Check: false,
        },
        hisPatientId: "",
        // 360健康视图
        mic: {
          latestMic: {}, // 当前在用360协议信息
          curMic: {}, // 当前就诊人360协议签署状态
          showCurProtocol: false, // 预约挂号-默认不展示签署模块
        },
        agree360isValid: false, // 360个人知情同意书是否勾选最新版
        agreeCheck: false, // 预约挂号-勾选协议

        patientDeatiData: {},
        examBookList: {},
        ifSuccess: true,
        phone: "",
        idNo: "",
        idNoHide: "",
        name: "",
        gender: "",
        birthday: "",
        idType: "",
        reserveId: "",
        packageName: "",
        packagePrice: "",

        paymentVisible: false,   // 显示支付弹框
        paymentQrCode: "",       // 二维码显示链接
        paymentRecord: {         // 支付数据信息

        },
        timer: "",               // 定时器
        num: 120,                 // 二维码展示倒计时时长

        paySuccessTimer: "",      // 支付成功计时器
        paySuccessNum: 5,         // 支付成功展示时间
        paySuccessVisible: false, // 显示支付成功

        paymentFee: "",            // 支付金额
        examBooKMail: "",          // 体检预约套餐
        examBookTime: "",          // 体检预约时间

        payPhoneVisible: false,    // 手机支付弹框显示
        hospitalCode: "H06",       // 医院编码

        showHasPaySuccess: false,  // 手机支付中弹框

        paymentLock: true, // 手机支付锁，防止多次点击去支付

        codeTimer:null,
        codeSecond:120,

        dutyDateList: [],          // 体检可预约日期

        selectPayPhoneVisible: false,
        paySelectValue: 2,         // 手机端目前只有微信支付，初始为微信支付
        payMethodValue: "alipay",  // 手机端目前只有微信支付，初始为微信支付

        packageSex: null,     // 体检套餐试用性别：1 男；2 女
      }
    );
  },

  created() {
    this.getPublicKey();
    this.getMedicalExamDetail();
    this.consultantForm.hospitalCode = this.hospitalCode;
  },
  mounted() {
    this.getMicUsing() // 360个人知情同意书-当前再用信息
  },

  methods: {
    //去支付
    // payQrCode() {
    //   this.$API
    //     .payQrCode({
    //       sys: "H05",
    //       source:"website",
    //       platform:"alipay",
    //       payType:"app",
    //       businessId:"C1",
    //       businessType:" 体检套餐支付",
    //       productId:this.reserveId+","+this.packageCode,
    //       productName:this.packageName,
    //       totalFee:this.packagePrice,
    //       buyerId:this.hisPatientId,
    //       accessType:"5",
    //     })
    //     .then(res => {
    //    console.log("---------------------------",res)
    //     });
    // },
    pickerOptions(current) {
      return current && (current.valueOf() < new Date('1900', '0', '1').getTime()) || (current.valueOf() > new Date().getTime());
    },
    stepChange(current) {
      console.log("onChange:", current);
      if (current > this.current) {
        return
      }
      this.current = current;
    },
    getMedicalExamDetail() {
      this.$API
        .getMedicalExamDetail({
          hospitalCode: this.hospitalCode,
          packageCode: this.packageCode,
          type: 'I'    // 类型 个人：I，团体：G
        })
        .then(res => {
          // this.$set(this, "medicalExamDetailData", res.data.itemList);
          let dataList=res.data.typeList;
          let itemList=[];
          for(let i=0;i<dataList.length;i++){
            for(let j=0;j<dataList[i].itemList.length;j++){
              itemList.push(dataList[i].itemList[j])
            }
          }
          this.$set(this, "medicalExamDetailData", itemList);
          console.log("medicalExamDetailData:",this.medicalExamDetailData);
          this.packageName = res.data.packageName;
          this.packageSex = res.data.packageSex;
        });
    },
    showMask() {
      this.showMoreFlag = true;
      this.$nextTick(() => {
        const top = this.$refs.yyxzref.offsetTop - 200
        this.setParentScroll(top)
      })
    },
    closeRemindPop() {
      this.showMoreFlag = false;
    },
    checkChange(e) {
      // console.log(`checked = ${e.target.checked}`);
      if (e.target.checked == true) {
        this.showNextBtn = true;
      } else {
        this.showNextBtn = false;
      }
    },
    //体检预约
    confirmAppointment() {
      this.showTableDetail = false;
      this.showMoreFlag = false;
      this.getExamDutyDate(); //获取可预约日期
      this.getPatientList(); //获取就诊人列表,会进行登录判断
    },

    handleSeletcPatientChange(hisPatientId) {
      this.hisPatientId = hisPatientId;
      // this.getPatientDeatil();
      for (let i = 0; i < this.hisPatientNameList.length; i++) {
        if (this.hisPatientNameList[i].hisId == hisPatientId) {
          this.$set(this, "patientDeatiData", this.hisPatientNameList[i]);
          this.idNo = this.hisPatientNameList[i].idNo;
          this.idNoHide = this.hisPatientNameList[i].idNoHide;
          this.phone = this.hisPatientNameList[i].phone;
          this.hisPatientName = this.hisPatientNameList[i].name;
          this.gender = this.hisPatientNameList[i].gender;
          this.birthday = this.hisPatientNameList[i].birthday;
          this.idType = this.hisPatientNameList[i].idType;
          this.curPatient = this.hisPatientNameList[i];
        }
      }
      console.log(' this.hisPatientId ----------------', hisPatientId)
      // this.queryMicSignStatus();
    },
    async handleSubmit() {
      if(this.examBookForm.reserveDate == ''){
        this.$message.warning("请选择预约日期");
        return
      }
      if(this.examBookForm.hisPatientName ==''){
        this.$message.warning("请选择就诊人");
        return;
      }
      if(this.packageSex != "3" && this.packageSex != this.gender){
        this.$message.warning("请选择适合套餐的就诊人");
        return
      }
      /* this.$loading();
      this.getMedicalExamBook(); */
      const patientInfo = this.curPatient || {};
      const {hisId, name} = patientInfo;
      const {signStatus, micVersion, id } = this.mic.curMic;
      // try { 
      //   /*
      //     360视图签署
      //     判断当前是否签署过，如果签署过则不用再次签署
      //     signStatus: 1 签署过 0 没签署过
      //   */
      //   const signStatusNum = this.agreeCheck ? "1" : "0";
      //   console.log(`${name}-当前(${signStatus})-${signStatusNum}`)
      //   if (signStatus == 0) {
      //     // 去签署
      //     const sendMsg = {
      //       hospitalCode: 'H06',
      //       hisId: hisId,
      //       patientName: name,
      //       micId: id,
      //       micVersion,
      //       signStatus: signStatusNum,
      //       secondSource: MIC_CONFIG.source // 正式：boegw  测试：GW
      //     }
      //     console.log(sendMsg)
      //     const micSignRes = await this.$API.getMicSignSingle(sendMsg);
      //   }
      // } catch (error) {}

      this.$loading()
      this.getMedicalExamBook()
    },
    addNewPatient() {
      this.confirm = true;
    },
    // 加密
    setEncrypt(msg) {
      let jsencrypt = new JSEncrypt({});
      jsencrypt.setPublicKey(this.publicKey);
      return jsencrypt.encrypt(msg);
    },
    // 获取公匙
    getPublicKey() {
      this.$API.rsaPublic().then((res) => {
        if (res.code == 0) {
          this.publicKey = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    //获取验证码
    getVerifyCode(value) {
      if (!this.consultantForm.phone) {
        this.$message.warning("请输入手机号");
        return;
      }
      if(this.codeTimer){
        return;
      }
      let obj = {
        phone: this.consultantForm.phone,
        language: "zh",
        purpose: "V",
        sys: "ohealth",
        templateNo: "ohealth-code"
      };
      this.$API.szSendYzm(obj).then(res => {
        if (res.code == 0) {
          this.$message.success("获取验证码成功！");
          this.codeTimer = setInterval(() => {
            this.codeSecond--;
            if(this.codeSecond==0){
              clearTimeout(this.codeTimer)
              this.codeTimer=null
            }
          }, 1000);
        } else {
          this.$message.error(res.msg);
        }
        this.codeSecond=120;
      });
    },
    // 查询个人知情同意书在用信息
    getMicUsing() {
      const _this = this
      this.$API.getMicUsingSingle({
        hospitalCode: 'H06'
      }).then((res) => {
        if (res.code == 0 && res.data?.micUrl) {
          _this.mic.latestMic = res.data;
        }
      });
    },
    // 请求该用户是否勾选过个人知情同意书
    async queryMicSignStatus() {
      const patientInfo = this.curPatient || {};
      const {hisId, name} = patientInfo;
      const params = {
        hospitalCode: 'H06',
        hisId,
        patientName: name,
      };
      const {code, data, msg} = await this.$API.getMicStatusSingle(params);
      console.log(data, '---签署状态---')
      if(code === '0') {
        let {micVersion, signStatus, validFlag, micUrl, id} = data;
        this.mic.curMic = {
          micUrl,
          micVersion,
          id,
          signStatus
        }
        // 如果没有签署过需要签署 signStatus=0 未签署 validFlag=1 协议有效
        if(signStatus === 0) {
          this.agreeCheck = false;
          this.mic.showCurProtocol = true;
        }
        else if (signStatus === 1) {
          this.agreeCheck = true;
          this.mic.showCurProtocol = false;
        }
      } else {
        this.$message.error(msg)
      }
    },
    // 新增就诊人确定
    async handleConsultantOk() {
      const _this = this
      if (!this.consultantForm.agreeCheck) {
        this.$message.warning('请先阅读并同意相关协议')
        return
      }
      console.log("新增就诊人表单", this.consultantForm);
      if (!this.consultantForm.name) {
        this.$message.error('请输入姓名');
        return false;
      }
      if (!this.consultantForm.birthday) {
        this.$message.error('请选择出生日期');
        return false;
      }
      if (this.consultantForm.idType == "01") {
        if (!checkIdNo(this.consultantForm.idNo)) {
          this.$message.error('身份证号格式错误，请检查后输入');
          return false;
        }
      }else if (this.consultantForm.idType == "13") {
        const p = /(^[A-Za-z0-9]{15}|^[A-Za-z0-9]{18})$/;
        if (!p.test(this.consultantForm.idNo)) {
          this.$message.error("证件号格式错误，请输入15或18位证件号");
          return false;
        }
      } else {
        if (!checkIdTypes(this.consultantForm.idNo)) {
          this.$message.error('证件号格式错误，仅支持数字,字母');
          return false;
        }
      }
      if (!checkPhoneNo(this.consultantForm.phone)) {
        this.$message.error('手机号码格式错误，请检查后重新输入');
        return false;
      }
      const Today = new Date(new Date().toLocaleString().split(" ")[0]).getTime();
      const getBirthday = new Date(this.consultantForm.birthday.replaceAll('-','/')).getTime();
      // 判断当前日期跟出生日期
      if (getBirthday > Today) {
        this.$message.error('出生日期不能晚于当前日期');
        return false;
      }
      this.confirmLoading = true;
      
      try {
        let phone = this.setEncrypt(this.consultantForm.phone);
        let idNo = this.setEncrypt(this.consultantForm.idNo);
        const addParams = JSON.parse(JSON.stringify({
          ...this.consultantForm,
          phone,
          idNo,
        }))
        let addRes = await this.$API.addPatient(addParams);
        // ----------------test------------------
        // addRes = {"code":"0","msg":"success","data":"020000676578","success":true}
        // ----------------test------------------
        console.log('新增就诊人接口', addRes)
        if (addRes.code == 0) {
          this.$message.success("新增成功！");
          // TODO: 360视图 0---
          // this.signSingleNew(addRes.data)
          // TODO: 360视图 1---
          this.closePop();
        } else {
          this.$message.error(addRes.msg);
        }
        this.confirmLoading = false
        const timer = setTimeout(() => {
          this.getPatientList() // 获取就诊人列表,会进行登录判断
          clearTimeout(timer)
        }, 3000)
      } catch (error) {}

    },
    async signSingleNew(hisId) {
      const _this = this;
      try {
        // 去签署
        const signStatus = _this.consultantForm.agree360Check ? "1" : "0";
        const sendMsg = {
          hospitalCode: _this.hospitalCode,
          hisId: hisId,
          patientName: _this.consultantForm.name,
          micId: _this.mic.latestMic.id,
          micVersion: _this.mic.latestMic.micVersion,
          signStatus,
          secondSource: MIC_CONFIG.source, // 正式：boegw  测试：GW
        }
        console.log('360视图 0', sendMsg)
        const micSignRes = await this.$API.getMicSignSingle(sendMsg);
      } catch (error) {}
    },
    // 关闭新增就诊人弹框
    closePop() {
      this.confirm = false;
      this.consultantForm = {
        sys: "ohealth",
        hospitalCode: this.hospitalCode,
        name: "",
        phone: "",
        idType: "01",
        idNo: "",
        birthday: "",
        gender: "1",
        relation: "0",
        verifyCode: "",
        source: "web",
      }
    },
    handleSelectChange() {
      console.log("11");
    },
    //获取验证码
    onSearch(value) {
      console.log(value);
    },
    getPatientDeatil() {
      this.$API
        .getPatientDeatil({
          hospitalCode: this.hospitalCode,
          hisId: this.hisPatientId
        })
        .then(res => {
          this.$set(this, "patientDeatiData", res.data);
          this.idNo = res.data.idNo;
          this.idNoHide = res.data.idNoHide;
          this.phone = res.data.phone;
          this.name = res.data.name;
          this.gender = res.data.gender;
          this.birthday = res.data.birthday;
          this.idType = res.data.idType;
          console.log("this.idType", this.idTyp);
        });
    },
    //体检预约
    getMedicalExamBook() {
      debugger;
      this.$API
        .getMedicalExamBook({
          hospitalCode: 'H06',
          packageCode: this.packageCode,
          packageName: this.packageName,
          hisPatientId: this.hisPatientId,
          hisPatientName: this.hisPatientName,
          sex: this.gender,
          phone: this.phone,
          birthday: this.birthday,
          reserveDate: this.examBookForm.reserveDate,
          idNo: this.idNo,
          idType: this.idType,
        })
        .then(
          res => {
            if (res.code == 0) {
              this.current = 1;
              this.$set(this, "examBookList", res.data);
              // this.$message.success("预约成功！");
              this.paymentRecord = res.data
              this.ifSuccess = true;
              this.steps[1].title = "预约成功";
              this.$loading().close();
            } else {
              this.ifSuccess = false;
              this.steps[1].title = "预约失败";
              this.$loading().close();
            }
          },
          error => {
            this.$loading().close();
            this.ifSuccess = false;
            this.steps[1].title = "预约失败";
            // this.erroeMsg = error.msg;
          }
        );
    },
    //获取出生日期
    getBirthday(psidno) {
      var birthdayno, birthdaytemp;
      if (psidno.length == 18) {
        birthdayno = psidno.substring(6, 14);
      } else if (psidno.length == 15) {
        birthdaytemp = psidno.substring(6, 12);
        birthdayno = "19" + birthdaytemp;
      } else {
        return "";
      }
      var birthday =
        birthdayno.substring(0, 4) +
        "-" +
        birthdayno.substring(4, 6) +
        "-" +
        birthdayno.substring(6, 8);
      return birthday;
    },
    //获取就诊人列表
    getPatientList() {
      let ut = localStorage.getItem('ut');
      // localStorage中没有ut，判断是否登录
      if(ut == undefined || ut == null || ut == ""){
        this.$router.push({
          path: 
            "/personalCenter/login",
          query: {redirect: '/medicalCenter/medicalPlan'} // 将跳转的路由path作为参数，登录成功后跳转到该路由
        })
        return
      }
      this.$API
        .patientList({
          hospitalCode: this.hospitalCode
        })
        .then(
          res => {
            this.$set(this, "hisPatientNameList", res.data);
          },
          error => {
            if (error.code == "9999") {
              this.$router.push(
                  "/personalCenter/login"
              );
            }
          }
        );
    },

    // 获取可选日期
    getExamDutyDate(){
      let data = {
        hospitalCode:this.hospitalCode
      }
      this.$API.getExamDutyDate(data).then(res => {
        if(res.code == 0) {
          this.dutyDateList =  res.data;
        }
      })

      // 测试假数据
      // this.dutyDateList = [
      //   {
      //       date: "2021-09-29",
      //       dateFlag: 0,
      //       week: "星期三"
      //   },
      //   {
      //       date: "2021-09-30",
      //       dateFlag: 0,
      //       week: "星期四"
      //   },
      //   {
      //       date: "2021-10-01",
      //       dateFlag: 0,
      //       week: "星期五"
      //   },
      //   {
      //       date: "2021-10-02",
      //       dateFlag: 1,
      //       week: "星期六"
      //   },
      //   {
      //       date: "2021-10-03",
      //       dateFlag: 1,
      //       week: "星期日"
      //   },
      //   {
      //       date: "2021-10-04",
      //       dateFlag: 0,
      //       week: "星期一"
      //   },
      //   {
      //       date: "2021-10-05",
      //       dateFlag: 0,
      //       week: "星期二"
      //   },
      //   {
      //       date: "2021-10-06",
      //       dateFlag: 0,
      //       week: "星期三"
      //   },
      //   {
      //       date: "2021-10-07",
      //       dateFlag: 0,
      //       week: "星期四"
      //   },
      //   {
      //       date: "2021-10-08",
      //       dateFlag: 0,
      //       week: "星期五"
      //   }
      // ]
    },

    // 生成支付二维码
    getQrCode(){
      this.timer = setInterval(this.clock, 1000);
      let that = this;
      // this.paymentQrCode="https://qr.95516.com/01020001/wcqr?f=ICBCqr&X=1&T=3&P=13&I=e03d925776684b4d&N=eda2cd4a81a690c8a44f6a1288309c1b&L=0fe51c864aef965d696f79225b4a271785d4670d20ce2e676a7e89b9a1d132589704dc03df521bc68c70ba61e2622fa2"
      console.log("this inside qrcode:",that.paymentQrCode);
      let qrcode = require("qrcodejs2");
      document.getElementById("qrcode").innerHTML = '';
      new qrcode(document.getElementById("qrcode"), {
        text: that.paymentQrCode,
        width: 183,
        height: 183,
        correctLevel: qrcode.CorrectLevel.Q
      });
    },
    // 计时器
    clock() {
      if (this.num > 0) {
        if(this.num%2 != 0){
          this.checkExamPaymentStatus(); // 检查体检预约支付状态
        }
        this.num--;
      } else {
        // this.closePaymentModal();
        clearInterval(this.timer);
        this.num = 120;
        this.goExamPayment();
      }
    },

    // 检查体检预约支付状态
    checkExamPaymentStatus(){
      // hisPatientId
      // const enDes = encryptByDES(this.hisPatientId, '6519625babf183f8')
      // const encodeEnDes = window.encodeURIComponent(enDes)
      const hisPatientId = this.setEncrypt(this.hisPatientId);
      const encodeEnDes = window.encodeURIComponent(hisPatientId);
      // idNo
      // const idNoEnDes = encryptByDES(this.idNo, '6519625babf183f8')
      const idNoEnDes = this.idNo
      const idNoEncodeEnDes = window.encodeURIComponent(idNoEnDes)
      let data = {
        hospitalCode: this.hospitalCode,
        hisPatientId: encodeEnDes,
        idNo: idNoEncodeEnDes,
        idType: this.idType,
        reserveNetId: this.paymentRecord.reserveId,
      }
      this.$API.checkExamPaymentStatus(data)
      .then(
        res => {
          console.log("checkExamPayStatus res:",res);
          if(res&&res.code=="0"){
            if(res.data == "1"){
              // this.getExamTableList();
              if(this.SCREEN.mobile){
                this.closePayPhoneModal();
              }else{
                this.closePaymentModal();
              }
              this.openPaySuccessModal();
            }
          }
        },
        error => {
          console.log("checkExamPaymentStatus error:", error);
          if(this.SCREEN.mobile){
            this.closePayPhoneModal();
          }else{
            this.closePaymentModal();
          }
        }
      );
    },

    // 关闭支付弹窗
    closePaymentModal(){
      this.paymentVisible = false;
      document.getElementsByClassName('examBook')[0].style.position = "unset";
      document.getElementsByClassName('examBook')[0].style.zIndex = 5;
      clearInterval(this.timer);
      this.num = 120;
    },

    // 支付成功弹窗
    openPaySuccessModal(){
      this.paySuccessVisible = true;
      document.getElementsByClassName('examBook')[0].style.position = "relative";
      document.getElementsByClassName('examBook')[0].style.zIndex = 1000;
      // 支付成功计时器
      this.paySuccessTimer = setInterval(this.successClock, 1000);
    },
    // 支付成功计时器
    successClock(){
      if (this.paySuccessNum > 0) {
        this.paySuccessNum--;
      } else {
        this.closePaySuccessModal();
      }
    },
    // 关闭支付成功弹窗
    closePaySuccessModal(){
      this.paySuccessVisible = false;
      document.getElementsByClassName('examBook')[0].style.position = "unset";
      document.getElementsByClassName('examBook')[0].style.zIndex = 5;
      clearInterval(this.paySuccessTimer);
      this.paySuccessNum = 5;
     this.$router.push("/personalCenter/personalList");
    },

    // 手机端支付方式选择
    selectPaymentPhone(){
      this.selectPayPhoneVisible = true;
    },
    // 选择手机支付方式
    onChangePayMethod(e){
      console.log("onChangePayMethod value:", e);
      console.log("onChangePayMethod paySelectValue:", this.paySelectValue);
      if (e.target.value == 1){
        this.payMethodValue = 'wxpay';
      } else if (e.target.value == 2) {
        this.payMethodValue = 'alipay';
      }
    },
    payMenthodCancel(){
      this.selectPayPhoneVisible = false;
    },
    // 确认选择手机支付
    payMenthodConfirm(){
      if(this.payMethodValue == null) {
        this.$message.warning("请选择支付方式");
        return;
      }
      this.goExamPaymentPhone();
      // this.selectPayPhoneVisible = false;
    },

    // 体检去付款
    goExamPayment(){
      if(this.paymentLock = false){
        return;
      }
      if(this.paymentLock = true){
        this.paymentLock = false;
      }
      let record = this.paymentRecord;
      let orderCode = record.reserveId;
      let hisPatientId = this.hisPatientId;
      let fee = record.packagePrice*100;    // 按分计算，返回值乘以100为元
      // this.paymentRecord = record;
      this.paymentFee = record.packagePrice;
      this.examBooKMail = record.packageName;
      this.examBookTime = record.reserveDate;
      let data = {
        sys: "H06",
        source: "qr",
        platform: "wxpay",
        payType: "web",
        businessId: "C1",
        businessType: "体检套餐支付",
        productId: orderCode,
        productName: this.examBooKMail,
        totalFee: fee,            // 按分计算，返回值乘以100为元
        buyerId: hisPatientId,
        payId: null,
        openId: null,
        unionId: null,
        bizChannel: 7,
        // accessType: 10,
      }
      this.$API.goPaySuzhou(data).then(res => {
        this.paymentLock = true;
        console.log("goPay res:",res);
        if(res&&res.code=="0"){
          this.paymentQrCode = res.data.payParams.qrContent;
          this.paymentVisible = true;
          this.getQrCode();
        }
      });
    },

    // 打开手机支付中弹框
    openPayPhoneModal(){
      // this.payPhoneVisible = true;
      // this.timer = setInterval(this.phoneClock, 1000);
      // this.showHasPaySuccess = true;
      let timer = setTimeout(() => {
        this.showHasPaySuccess = true;
        clearTimeout(timer);
      }, 3000);
    },

    // 手机计时器
    phoneClock() {
      if (this.num > 0) {
        this.checkExamPaymentStatus(); // 检查体检预约支付状态
        this.num--;
      } else {
        this.closePayPhoneModal();
      }
    },
    // 关闭手机支付中弹框
    closePayPhoneModal(){
      this.payPhoneVisible = false;
      clearInterval(this.timer);
      this.num = 120;
    },

    // 体检手机端去付款
    goExamPaymentPhone(){
      if(this.paymentLock = false){
        return;
      }
      if(this.paymentLock = true){
        this.paymentLock = false;
      }
      let record = this.paymentRecord;
      let orderCode = record.reserveId;
      let hisPatientId = this.hisPatientId;
      let fee = record.packagePrice*100;    // 按分计算，返回值乘以100为元
      // this.paymentRecord = record;
      this.paymentFee = record.packagePrice;
      this.examBooKMail = record.packageName;
      this.examBookTime = record.reserveDate;
      let data = {
        sys: "H06",
        source: "h5",
        platform: this.payMethodValue, // 微信：wxpay; 支付宝：alipay;
        payType: "web",
        businessId: "C1",
        businessType: "体检套餐支付",
        productId: orderCode,
        productName: this.examBooKMail,
        totalFee: fee,            // 按分计算，返回值乘以100为元
        buyerId: hisPatientId,
        payId: null,
        openId: null,
        unionId: null,
        bizChannel: 7,
        // accessType: 10,
      }
      this.$API.goPaySuzhou(data).then(res => {
        this.paymentLock = true;
        console.log("goPayPhone res:",res);
        if(res&&res.code=="0"){
          this.paymentQrCode = res.data;
          // this.paymentVisible = true;
          // this.getQrCode();

          // let u = navigator.userAgent;
          // let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
          // let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
          // if(isAndroid) {  //android终端
          //   window.open(this.paymentQrCode,"_blank");
          // }else if(isiOS) {   //ios终端
          //   window.location.href = this.paymentQrCode;
          // }

          this.selectPayPhoneVisible = false;
          this.payMethodValue = null;
          var divBody = document.createElement('div');
          divBody.innerHTML = res.data.payParams.form;
          document.body.appendChild(divBody);
          document.forms[0].submit();

          // this.openPayPhoneModal()
        }
      });
    },

    // 已完成支付
    hasPaySuccess() {
      this.showHasPaySuccess = false;
      this.$router.push("/personalCenter/personalList");
    },
    // 重新支付
    refreshPay() {
      this.selectPaymentPhone(); // 调用门诊支付接口
    },

    // 输入身份证号自动带出出生日期
    enterIdNo() {
      if(this.consultantForm.idType == '01' && this.consultantForm.idNo.length == 18) {
        let str1 = this.consultantForm.idNo.substring(6, 10);
        let str2 = this.consultantForm.idNo.substring(10, 12);
        let str3 = this.consultantForm.idNo.substring(12, 14);
        let gender = this.consultantForm.idNo.substring(16, 17);
        this.consultantForm.birthday = str1 + '-' + str2 + '-' + str3;
        if (gender%2 == 1){
          this.consultantForm.gender = "1"; 
        } else {
          this.consultantForm.gender = "2";
        }
      }
    },
  },


  beforeDestroy(){
    this.codeTimer&&clearTimeout(this.codeTimer)
  }
};
</script>

<style lang="less" scoped>
.examBook{
  padding: 1.25rem 0rem
}
/deep/.ant-steps {
  padding-top: 0px;
  .ant-steps-item-tail {
    height: 7px;
    background: #d8d8d8;
    top: 0;
    margin-left:20px;
  }
  .ant-steps-item-content{
    text-align:left;
    width:100%;
  }
  .ant-steps-item-tail:after {
    background: #d8d8d8;
  }
  .ant-steps-item-finish>.ant-steps-item-container>.ant-steps-item-tail:after,
  .ant-steps-item-finish .ant-steps-item-tail {
    background-color: #1890ff;
  }
  .ant-steps-item-icon{
    margin-left:0!important
  }
  .ant-steps-icon-dot {
    width: 0.4rem;
    height: 0.4rem;
    max-width:24px;
    max-height:24px;
    background: #d8d8d8;
    border-radius: 50%;
    top: 50% !important;
    transform: translateY(-50%);
  }
  .ant-steps-item-title {
    padding-top: 20px;
    font-size:14px!important;
  }
  .ant-steps-item-finish {
    .ant-steps-icon-dot {
      background: #0078d4 url(../images/liucheng-1.png) no-repeat center;
      background-size:40%;
     width: 0.5rem;
      height: 0.5rem;
      max-height: 44px;
      max-width: 44px;
     top: 50% !important;
    transform: translateY(-50%);
    }
  }
  .ant-steps-item-active {
    .ant-steps-icon-dot {
      left: 0;
      width: 0.6rem;
      height:0.6rem;
       max-width:70px;
      max-height:70px;
      background: #bfdaee;
      top: 50% !important;
      transform: translateY(-50%);
    }
    .ant-steps-icon-dot:after {
      background: #0078d4 url(../images/liucheng-2.png) no-repeat center;
       background-size:40%;
      width: 0.5rem;
      height: 0.5rem;
      max-height: 44px;
      max-width: 44px;
      border-radius: 50%;
      top: 50% !important;
      left: 50%;
      transform: translate(-50%,-50%);
    }
  }
  .ant-steps-item-wait {
    .ant-steps-icon-dot {
      background: #d8d8d8;
    }
  }
}
/deep/.ant-steps-dot .ant-steps-item-icon,
.ant-steps-dot.ant-steps-small .ant-steps-item-icon {
  margin-left: 0 !important;
}
.m-screen-pc{
  /deep/ .ant-steps-item-active {
    .ant-steps-icon-dot {
      width: 1rem !important;
      height:1rem!important;
    }
  }
}
.m-screen-mobile{
  /deep/.ant-steps {
    padding-top: 0px;
  }
}
.mobileTable {
  padding-top: 0.4rem;
  .tableData {
    margin-bottom: 0.2rem;
    .item {
      border-top: 1px solid #ddd;
      display: flex;
      justify-content: center;
      font-size: 0.28rem;
      padding: 0.2rem 0;
      .left {
        width: 20%;
        text-align: right;
      }
      .right {
        width: 80%;

        padding-left: 0.1rem;
      }
    }
    .item:last-child {
      border-bottom: 1px solid #ddd;
    }
  }
  .more {
    padding: 0.4rem 0;
    display: flex;
    justify-content: center;
    .btn {
      font-size: 0.28rem;
      display: inline-block;
      vertical-align: top;
      border: 1px solid;
      border-radius: 1rem;
      padding: 0.1rem 0.3rem;
    }
  }
}
.bookSteps {
  position: relative;
  .title {
    text-align: center;
    font-size: 30px;
  }
  .steps {
    margin: 40px auto 0;
    /deep/.ant-steps {
      width: 100%;
    }
  }
  .btn2 {
    width: 200px;
    text-align: center;
    height: 45px;
    background: #0078c6;
    line-height: 45px;
    color: #fff;
    display: block;
    position: absolute;
    top: 89px;
    right: 165px;
    border-radius: 200px;
    font-size: 14px;
    span {
      position: relative;
      padding-left: 35px;
      display: inline-block;
    }
    span:before {
      content: "";
      display: block;
      background: url(../images/addpatient_alert1-img2.png) no-repeat center;
      width: 26px;
      height: 26px;
      position: absolute;
      top: 50%;
      margin-top: -13px;
      left: 0;
    }
  }
  .box {
    padding-top: 70px;
    /deep/.ant-form-item {
      margin-top: 30px;
      margin-bottom: 0 !important;
    }
    .steps-content1 {
      .tit1 {
        font-size: 20px;
        border-bottom: 1px solid #dbdbdb;
        padding-bottom: 14px;
      }

      .confirmBtn {
        margin-top: 25px;
        a {
          background: #0078d4;
          font-size: 16px;
          border-radius: 200px;
          text-align: center;
          display: inline-block;
          padding: 12px 60px;
          color: #fff;
          &.dis {
            color: rgba(0, 0, 0, 0.25);
            background-color: #f5f5f5;
            border-color: #d9d9d9;
          }
          i {
            padding: 4px 0;
            padding-left: 43px;
            background: url(../images/guahao3page1-img2.png) no-repeat left
              center;
            font-style: normal;
            color: inherit;
            display: inline-block;
          }
        }
      }
      .guahao3page1_alert {
        -webkit-box-shadow: 0px 1px 12px 0px #f5f5f5;
        box-shadow: 0px 1px 12px 0px #f5f5f5;
        width: 100%;
        height: 470px;
        position: absolute;
        bottom: -20px;
        left: 0;
        background: #fff;
        z-index: 999;
        .close {
          position: absolute;
          top: 20px;
          right: 21px;
          background: url(../images/close.jpg) no-repeat center;
          display: block;
          width: 23px;
          height: 23px;
        }
        .inner {
          padding: 55px 60px;
          padding-bottom: 80px;
          .tit2 {
            font-size: 30px;
          }
          .ant-form {
            margin-top: 34px;
            display: flex;
            flex-wrap: wrap;
            .ant-form-item {
              width: 30%;
              margin: 0;
              margin-bottom: 20px;
            }
          }

          .guahao3page1-button {
            margin-top: 25px;
            a {
              background: #0078d4;
              font-size: 16px;
              border-radius: 200px;
              text-align: center;
              display: inline-block;
              padding: 12px 60px;
              color: #fff;
              &.dis {
                color: rgba(0, 0, 0, 0.25);
                background-color: #f5f5f5;
                border-color: #d9d9d9;
              }
              i {
                padding: 4px 0;
                padding-left: 43px;
                background: url(../images/guahao3page1-img2.png) no-repeat left
                  center;
                font-style: normal;
                color: inherit;
                display: inline-block;
              }
            }
          }
        }
      }
    }
    .steps-content2 {
      .boxFail {
        .statebox {
          background-size: 143px 143px !important;
          font-size: 30px;
          text-align: center;
          font-weight: bold;
          background: url(../images/cha.png) no-repeat center top;
          padding-top: 175px;
        }
      }
    }
  }
  .boxSuccess {
    padding-top: 55px;
    .statebox {
      font-size: 30px;
      background: url(../images/guahao4page1.png) no-repeat center top;
      padding-top: 175px;
      text-align: center;
      font-weight: bold;
      .tit {
      }
      .btnSearch {
        margin-top: 72px;
        display: flex;
        justify-content: center;
        > a {
          font-size: 18px;
          color: #ffffff;
          text-align: center;
          font-weight: 700;
          width: 240px;
          height: 56px;
          line-height: 56px;

          display: block;

          border-radius: 34px;
          span {
            position: relative;
            display: inline-block;
          }

          span:before {
            content: "";
            display: block;

            width: 20px;
            height: 20px;
            position: absolute;
            top: 50%;
            margin-top: -10px;
            left: 0;
          }
        }
        .btn2_book {
          background: #65b3ec;
          margin-right: 40px;
          span {
            padding-left: 30px;
          }
          span:before {
            background: url(../images/addpatient_alert1-img2.png) no-repeat
              center;
          }
        }
        .btn2_pay {
          background: #0078d4;
          span {
            padding-left: 30px;
          }
          span:before {
            background: url(../images/pay_button_icon.svg) no-repeat center;
          }
        }
      }
    }
    .box2box {
      .boxitem {
        padding-top: 45px;
        .tit1 {
          font-size: 20px;
          border-bottom: 1px solid #dbdbdb;
          padding-bottom: 14px;
        }
        .textlist {
          padding: 30px 0 0;
          display: flex;
          flex-wrap: wrap;
          .item1 {
            margin-right: 162px;
            font-size: 14px;
          }
        }
      }
      .boxitem:nth-child(1) {
        padding-top: 70px;
      }
      .boxitem:nth-child(2) {
        .textlist {
          .item1 {
            margin-right: 70px;
          }
        }
      }
    }
  }
}
// /deep/.ant-steps-item-content {
//   margin-top: 28px;
// }
// .ant-steps-item-active {
//   /deep/.ant-steps-icon-dot:before {
//     content: "";
//     display: block;
//     width: 50px;
//     height: 50px;
//     border-radius: 50%;
//     background: #0078d4;
//     position: absolute;
//     top: -22px;
//     left: 50%;
//     margin-left: -25px;
//   }
//   /deep/.ant-steps-icon-dot:after {
//     content: "";
//     display: block;
//     width: 24px;
//     height: 24px;
    
//     // background: #d8d8d8;
//     background: #c2e5ff;
//     position: absolute;
//     top: -9px;
//     left: 50%;
//     border-radius: 50%;
//     margin-left: -12px;
//   }
// }
.windowInfoWrap {
  .tableDetail {
    .title1 {
      font-size: 30px;
      text-align: center;
    }
    .tablebox {
      margin-top: 42px;
      /deep/.ant-table-thead > tr:first-child > th {
        background: #0078d4;
        font-size: 16px;
        height: 56px;
        text-align: center;
        color: #fff;
        font-weight: 100;
        border-left: 2px solid #fff;
      }
      /deep/.ant-table-tbody > tr > td {
        text-align: center;
        color: #474747;
        a {
          color: #474747;
        }
      }
    }
  }
  .tip {
    display: flex;
    font-size: 16px;
    line-height: 26px;
    padding-top: 30px;
    .s1 {
      width: 49px;
      height: 38px;
      line-height: 38px;
    }
    .desc {
      text-align: justify;
    }
  }
  .moreBtn {
    text-align: center;
    margin-top: 54px;
    a {
      background: #0078d4;
      font-size: 16px;
      border-radius: 200px;
      text-align: center;
      display: inline-block;
      padding: 12px 60px;
      color: #fff;
      i {
        padding: 4px 0;
        padding-left: 43px;
        background: url(../images/guahao3page1-img2.png) no-repeat left center;
        font-style: normal;
        color: inherit;
        display: inline-block;
      }
    }
  }
}
.mask50 {
  background: url(../images/mask50.png);
  width: 100%;
  height: 100%;
  z-index: 2001;
  position: fixed;
  top: 0;
  left: 0;
}
.contactfixed {
  overflow-y: auto;
  max-height: 5rem;
  width: 9rem;
  position: fixed;
  top: 50%;
  left: 50%;

  transform: translate(-50%, -50%);
  z-index: 2002;
  background: #fff;
  .close {
    background: url(../images/close.jpg) no-repeat center;
    width: 0.35rem;
    height: 0.35rem;
    position: absolute;
    top: 0.23rem;
    right: 0.2rem;
  }

  .inner {
    padding: 0.6rem 0.4rem;
    .scroll {
      // height: 4rem;
      overflow: hidden;
      .mCustomScrollBox {
        position: relative;
        overflow: hidden;
        height: 100%;
        max-width: 100%;
        outline: none;
        direction: ltr;
        .mCSB_container {
          overflow: hidden;
          width: auto;
          height: auto;
          margin-right: 0.3rem;
          .tit {
            font-size: 30px;
            text-align: center;
          }
          .content {
          }
        }
      }
    }
    .operbox {
      text-align: center;
      margin-top: 20px;
      .got1 {
        display: inline-block;
        color: blue;
        display: inline-block;
        vertical-align: middle;
        font-size: 0;

        // label {
        vertical-align: middle;
        font-size: 14px;
        margin-left: 5px;
        // }
      }
      .nextBtn {
        display: inline-block;
        .operbtn1 {
          background: #0078d4;
          font-size: 16px;
          border-radius: 5px;
          padding: 12px 60px;
          color: aliceblue;
          margin: 0 10px;

          vertical-align: middle;
        }
      }
    }
  }
}

// 支付蒙层
.wemsk {
  background: url(../images/mask50.png);
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 99;
  left: 0;
  top: 0;
  display: block;
}
// 支付弹框
.pay-model-box {
  position: fixed;
  top: 50%;
  left: 50%;
  margin-top: -288px;
  margin-left: -331px;
  width: 662px;
  height: 576px;
  z-index: 9999;
  background-color: #fff;
  border-radius: 4px;
  .pay-main-box {
    .title {
      width: 100%;
      height: 120px;
      background-color: #F8F9FF;
      .top-title {
        padding-top: 20px;
        text-align: center;
        font-size: 18px;
        position: relative;
        font-weight: bold;
        .close-span {
          position: absolute;
          right: 20px;
          top: 0px;
          color: #999;
          font-size: 30px;
          font-weight: normal;
        }
      }
      .two-box {
        margin: 10px 0;
        text-align: center;
        font-size: 12px;
        span {
          font-weight: bold;
        }
      }
      .three-box {
        text-align: center;
        span {
          font-weight: bold;
        }
      }
    }
    .pay-money {
      text-align: center;
      font-weight: bold;
      font-size: 14px;
      span {
        color: #FF4D4F;
        font-size: 24px;
      }
    }
    .img-box {
      margin-top: 20px;
      box-sizing: border-box;
      padding: 0 80px;
      display: flex;
      justify-content: space-between;
      .left-img-box {
        border: 1px solid #ddd;
        .qrcode-out-box {
          padding: 20px;
          .qrcode-box {
            width: 183px;
            height: 183px;
          }
        }
        .bottom-remind-box {
          box-sizing: border-box;
          // margin-top: 12px;
          padding-top: 8px;
          padding-left: 20px;
          border-top: 1px solid #ddd;
          &::after {
            clear: both;
            display: block;
            content: "";
            overflow: hidden;
          }
          .img {
            float: left;
          }
          .txt {
            margin-left: 20px;
            float: left;
            font-size: 12px;
          }
        }
      }
      .right-img-box {
        img {
          width: 210px;
          height: 288px;
        }
      }
    }
    .red-txt-box {
      margin-top: 20px;
      padding: 0 80px;
      .content-red-box {
        background-color: #FFF1F0;
        border: 1px solid #FFA39E;
        padding-left: 24px;
        height: 40px;
        line-height: 40px;
        img {
          margin-right: 8px;
          display: inline;
        }
      }
    }
  }
}
// 支付成功弹框
.pay-success-model-box {
  position: fixed;
  top: 50%;
  left: 50%;
  margin-top: -130px;
  margin-left: -331px;
  width: 662px;
  height: 260px;
  z-index: 9999;
  background-color: #fff;
  border-radius: 4px;
  .top-title {
    margin-top: 20px;
    text-align: center;
    font-size: 18px;
    position: relative;
    font-weight: bold;
    .close-span {
      position: absolute;
      right: 20px;
      top: -16px;
      color: #999;
      font-size: 30px;
      font-weight: normal;
    }
  }
  .middle-box {
    margin: 60px 0;
    text-align: center;
    font-size: 18px;
    font-weight: bold;
    img {
      width: 50px;
      height: 50px;
      display: inline;
      margin-right: 20px;
    }
    span {
      color: #FF7F81;
    }
  }
  .bottom-box {
    text-align: center;
    font-size: 12px;
    color: #404555;
  }
}

// 手机支付弹框
.has-pay-success {
  position: fixed;
  width: 4rem;
  height: 2.5rem;
  z-index: 9999;
  top: 30%;
  left: 20%;
  background-color: #fff;
  border-radius: 6px;
  .gth-box {
    margin-top: 0.2rem;
    text-align: center;
    .gth {
      display: inline-block;
      width: 0.5rem;
      height: 0.5rem;
      border-radius: 50%;
      border: 1px solid red;
      color: red;
    }
  }
  .txt {
    margin: 10px 0;
    text-align: center;
  }
  .btn-box {
    display: flex;
    justify-content: space-between;
    padding: 0 0.2rem;
    p {
      border: 1px solid #ddd;
      padding: 0.1rem 0.2rem;
      border-radius: 0.5rem;
    }
    .red-btn {
      background-color: red;
      border-color: red;
      color: #fff;
    }
  }
}

// 支付方式选择
.payRadioGroup {
  padding: 20px 40px;
  .payMethodRadio1{
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  /deep/ .payMethodRadio{
    display: flex;
    align-items: center;
  }
}
.topaybtn{
  text-align:center;
  display:flex;
  margin-top: 10px;
  justify-content: center;
  .topaybtn1{
    margin: 10px;
  }
}

.m-screen-mobile {
  margin-bottom: 1rem;
  padding-left: 0.25rem;
  padding-right: 0.25rem;
  
  .title1 {
    font-size: 0.4rem !important;
    text-align: center;
  }
  .tip {
    font-size: 0.24rem;
    line-height: 1.4;
    padding-top: 0;
    .s1 {
      width: 2rem;
      height: 0.38rem;
      line-height: 0.38rem;
    }
    .desc {
      // margin-left: 0.8rem;
    }
  }
  #tjjzr{
    font-size:12px;
  }
  .moreBtn {
    margin-top: 0.4rem;
    a {
      width: 100%;
      font-size: 0.28rem;
      padding: 0.1rem 0.8rem;
      i {
        background-size: 0.5rem;
        padding: 0.1rem 0;
        padding-left: 0.55rem;
      }
    }
  }
  .contactfixed {
    width: 95%;
    max-height: 6rem;

    .close {
    }

    .inner {
      padding: 0.5rem 0.3rem;
      .scroll {
        height: 4.5rem;
        .mCSB_container {
          .tit {
            font-size: 0.3rem;
          }
          .content {
          }
        }
      }
    }
    .operbox {
      margin-top: 0.2rem;
      .got1 {
        font-size: 0.14rem;
      }
      .nextBtn {
        .operbtn1 {
          font-size: 0.26rem;
          padding: 0.08rem 0.5rem;
          margin: 0 0.1rem;
          border-radius: 0.1rem;
          border-radius: 0.1rem;
        }
      }
    }
  }
  .bookSteps {
    .title {
      font-size: 0.4rem;
    }
    // .steps {
    //   margin-top: 0.6rem;
    //   width: auto;
    //   /deep/.ant-steps {
    //     width: 100%;
    //   }
    // }
    .btn2 {
      width: 4rem;
      margin: 0 auto;
      height: auto;
      line-height: normal;
      padding: 0.2rem 0.4rem;
      right: 0.3rem;
      top: 0.95rem;
      position: static;
      margin-top: 0.2rem;
      span {
        padding-left: 0.5rem;
      }
      span:before {
        width: 0.4rem;
        height: 0.4rem;
        margin-top: -0.18rem;
        background-size: cover;
      }
    }
    .confirmBtn {
      margin-top: 0.2rem;
      a {
        width: 100%;
        font-size: 0.28rem;
        padding: 0.1rem 0.8rem;
        i {
          background-size: 0.5rem;
          padding: 0.1rem 0;
          padding-left: 0.55rem;
        }
      }
    }
    .box {
      padding-top: 0.5rem;
      /deep/.ant-form-item {
        margin-top: 0.3rem;
      }
      /deep/.ant-calendar-picker {
        width: 100%;
      }
      /deep/.ant-form-item-label {
        padding: 0;
      }
      .steps-content1 {
        .tit1 {
          font-size: 0.3rem;
          padding-bottom: 0.2rem;
        }

        .guahao3page1_alert {
          height: fit-content;
          bottom:-200px;
          width: 100%;
          margin-left: 0;
          left: 0;
          .close {
            top: 0.1rem;
            right: 0.1rem;
            width: 0.3rem;
            height: 0.3rem;
            background-size: cover;
          }
          .inner {
            padding: 0.3rem;
            .tit2 {
              font-size: 0.4rem;
            }
            .ant-form {
              margin-top: 0.2rem;
              .ant-form-item {
                width: 100%;
                margin-bottom: 0.1rem;
              }
            }

            .guahao3page1-button {
              margin-top: 0.2rem;
              a {
                width: 100%;
                font-size: 0.28rem;
                padding: 0.1rem 0.8rem;
                i {
                  background-size: 0.5rem;
                  padding: 0.1rem 0;
                  padding-left: 0.55rem;
                }
              }
            }
          }
        }
      }
      .steps-content2 {
        .boxFail {
          .statebox {
            padding-top: 1.4rem;
            font-size: 0.4rem;
            margin: 0;
            background-size: 1.5rem 1.5rem !important;
            .tit {
              margin-top: 0.5rem;
            }
          }
        }
      }
    }
  }

  .pay-success-model-box {
    width: 300px;
    height: 210px;
    margin-left: -150px;
  }
}
</style>
